import Vue from "vue";
import HomePage from "./HomePage.vue";

export function load() {
  const selector = "home-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(HomePage, {
        props: {
          ...window[selector]
        }
      })
  }).$mount(selector);
}
